import { render, staticRenderFns } from "./TargetingWidget.vue?vue&type=template&id=537bbcf4&scoped=true&"
import script from "./TargetingWidget.vue?vue&type=script&lang=js&"
export * from "./TargetingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537bbcf4",
  null
  
)

export default component.exports